module.exports = __webpack_public_path__ + "static/media/icon_pbi-configure-success.6a414144.svg";